"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OVERVIEW_BUTTON = void 0;
const OVERVIEW_BUTTON = exports.OVERVIEW_BUTTON = 'overview-button';
